import { postEvents } from '@rmc/webcx-web-libs';
import { ClickTypeEnum } from '../../../../../types/clickType.d';

import { VERSION, API_URL_WEBCX } from '../../../../../config';

type PopupsApiCreateType<EventType> = {
	clientId: string;
	sessionId: string;
	userId: string;
	domainScopedSessionId: string;
	body?: object;
	previewQuery?: object;
	onError?: (
		e: unknown,
		variables: {
			eventType: EventType;
			campaignId: string;
			contentId: string;
			url?: string;
			type?: ClickTypeEnum;
		},
		context?: unknown
	) => void;
};

type OptsType = {
	campaignId: string;
	contentId: string;
	url?: string;
};

export function useEventsApiPostEvent<EventType>({
	clientId = '',
	sessionId = '',
	userId = '',
	domainScopedSessionId = '',
	previewQuery = {},
	onError = () => {},
}: PopupsApiCreateType<EventType>) {
	// NOTE: useMutation triggers extra rerenders
	// TODO: rewrite to useQuery or useMutate
	return async ({
		eventType,
		campaignId,
		contentId,
		url,
		type,
	}: {
		eventType: EventType;
		campaignId: string;
		contentId: string;
		url?: string;
		type?: ClickTypeEnum;
	}) => {
		const opts: OptsType = {
			campaignId,
			contentId,
			url,
		};

		try {
			const data = await postEvents({
				clientId,
				version: VERSION,
				sessionId,
				userId,
				domainScopedSessionId,
				eventType,
				opts,
				previewQuery,
				apiUrlConfig: API_URL_WEBCX,
			});

			return data;
		} catch (e) {
			onError(e, { eventType, campaignId, contentId, url, type });
			return null;
		}
	};
}
